import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

type Props = {
  onPress?: () => void
}

export default function AvatarDealsSection({ onPress }: Props) {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['configuration'])
  const text = 'configuration:start.sections.deals'

  const handlePress = () => {
    if (onPress) {
      onPress()
    } else {
      router.navigate('/deals')
    }
  }

  return (
    <>
      <Pressable
        onPress={handlePress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            className: 'overflow-hidden-fixer',
            animation,
            image: require('@/images/avatar/magnifier.png'),
            imageStyle: {
              transformOrigin: 'center',
              transform: [
                { translateX: 75 },
                { translateY: 0 },
                { scale: 0.75 },
              ],
            },
            blur: Platform.select({ default: 150, web: 30 }),
            blurStyle: {
              opacity: 0.75,
              transformOrigin: 'center',
              transform: [
                { translateX: Platform.select({ default: -50, web: 0 }) },
                { translateY: 25 },
                { scale: 0.5 },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
